import { Node, mergeAttributes } from '@tiptap/core';

const ActivityBlock = Node.create({
  name: 'activityBlock',
  group: 'block',
  content: 'block+',
  draggable: true,
  isolating: true, // Add this line

  addAttributes() {
    return {
      'data-id': {
        default: null,
        parseHTML: (element) => element.getAttribute('data-id'),
      },
      'data-type': {
        default: null,
        parseHTML: (element) => element.getAttribute('data-type'),
      },
    };
  },

  parseHTML() {
    return [{ tag: 'div.activity-block' }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes({ class: 'activity-block' }, HTMLAttributes),
      ['div', { class: 'drag-indicator' }],
      ['div', { class: 'content-container', contenteditable: 'true' }, 0],
    ];
  },
});

export default ActivityBlock;
